import { useState } from 'react';
import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import Image from '../../../../Core/Image';
import RichText from '../../../../Core/RichText';
import ChartRow from '../../../Chart/ChartRow';

import {
  ChartContainer,
  Container,
  Chart,
  ImageContainer,
  Heading,
  ChartHeaderContainer,
  Toggle,
  ToggleLabel,
  ToggleSwitch,
  ChartWrapper,
  Caption,
} from './styles';

const header = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <Heading>{children}</Heading>,
    [BLOCKS.HEADING_2]: (_, children) => <Heading>{children}</Heading>,
  },
};

const PointsChart = ({ data }) => {
  if (!data) return null;

  const { imageDam, elements } = data;
  const [checked, setChecked] = useState(true);

  const handleCheckbox = e => {
    window.dataLayer = window.dataLayer || [];
    const gtmData = {
      event: 'pco table toggle', // cta click event name
      action: e.target.checked ? 'points view' : 'percent view',
    };
    window.dataLayer.push(gtmData);
    setChecked(e.target.checked);
  };

  const chartData = elements.find(el => el.component === 'single-table');

  return (
    <ChartContainer>
      <Container>
        {imageDam && (
          <ImageContainer>
            <Image src={imageDam} alt={imageDam.altText || ''} />
          </ImageContainer>
        )}
        <ChartHeaderContainer>
          <RichText document={chartData.heading} options={header} />
          <ToggleLabel>
            <Toggle
              type="checkbox"
              checked={checked}
              onChange={handleCheckbox}
            />
            <ToggleSwitch />
            <span>
              {!checked ? chartData.toggleTextOpt : chartData.toggleText}
            </span>
          </ToggleLabel>
        </ChartHeaderContainer>
      </Container>
      <Chart>
        <ChartWrapper>
          {chartData.caption && (
            <Caption className="sr-only">
              <RichText document={chartData.caption} />
            </Caption>
          )}
          <tbody>
            {chartData.rows.map(row => (
              <ChartRow
                key={row.id}
                component={row.component}
                className="points-section"
                columnCount={row.columnCount}
                data={row.cells}
                percentage={!checked}
              />
            ))}
          </tbody>
        </ChartWrapper>
      </Chart>
    </ChartContainer>
  );
};

PointsChart.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default PointsChart;
